<script>
export default {
  props: {
    styleType: {
      default: 'info',
    },
  },
}
</script>

<template>
  <div class="alert" :class="`alert-${styleType}`"><slot /></div>
</template>
